import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { PasswordCaptureFields } from '../../types';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Lock } from 'lucide-react';

interface FieldsTabProps {
  form: UseFormReturn<PasswordCaptureFields>;
}

export function FieldsTab({ form }: FieldsTabProps) {
  useLanguage();
  return (
    <div className="space-y-6">
      {/* Lista de Campos */}
      <Card className="bg-white border border-[#E2E8F0] rounded-xl shadow-[0_2px_4px_rgba(0,0,0,0.02)]">
        <CardHeader className="pb-4">
          <CardTitle className="text-[17px] font-semibold text-[#101828]">{translateInterfaceText("Campo de Senha")}</CardTitle>
          <CardDescription className="text-[13px] text-[#667085]">
            {translateInterfaceText("Campo obrigatório para proteção por senha")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          {/* Campo Senha - Sempre ativo */}
          <div className="flex items-center gap-3 p-4 rounded-lg border bg-[#F7F8FE] border-[#E2E8F0]">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-[#EEF2FF]">
              <Lock className="h-5 w-5 text-[#2D6CF6]" />
            </div>
            <div className="flex-1 flex flex-col">
              <span className="font-medium text-[15px] text-[#1A1A1A]">
                {translateInterfaceText("Senha")}</span>
              <span className="text-[12px] text-[#6B7280] mt-0.5">
                {form.watch('content.password.placeholder')}
              </span>
            </div>

            <div className="flex items-center gap-3">
              <span className="text-sm font-medium text-[#2D6CF6]">
                {translateInterfaceText("Ativo")}</span>
              <Switch
                checked={true}
                disabled={true}
                className="data-[state=checked]:bg-[#3072FF]"
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
